import { Divider } from 'naan/primitives/divider';
import { VSpacer } from 'naan/primitives/spacer';
import { Text } from 'naan/primitives/text';
import React, { Fragment } from 'react';
import { CouponPurchase } from './coupon-purchase';

export const PurchasedCoupons = ({ coupons }: { coupons: any }) => {
  if (!coupons.length) {
    return null;
  }
  return (
    <div className="gift-coupons__purchased">
      <Text textStyle="medium-heading">My coupon purchases</Text>
      <VSpacer size={4} />
      <Divider />

      {coupons.map((coupon: any) => (
        <Fragment key={coupon.code}>
          <CouponPurchase coupon={coupon} />
          <Divider />
        </Fragment>
      ))}
      <VSpacer size={14} />
    </div>
  );
};
